import { render, staticRenderFns } from "./reviewsAftercare.vue?vue&type=template&id=29a28021&scoped=true"
import script from "./reviewsAftercare.vue?vue&type=script&lang=js"
export * from "./reviewsAftercare.vue?vue&type=script&lang=js"
import style0 from "./reviewsAftercare.vue?vue&type=style&index=0&id=29a28021&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a28021",
  null
  
)

export default component.exports